import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-staff-details',
  templateUrl: './staff-details.component.html',
  styleUrls: ['./staff-details.component.css']
})
export class StaffDetailsComponent implements OnInit {
  personnelId!: number;
  personnel: any;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.personnelId = +this.route.snapshot.paramMap.get('id')!;

    // Mock data for demo
    const mockPersonnel = {
      "personnel_id": 1,
      "employee_code": 1,
      "full_name": "Rishabh Awasthi",
      "role": "Staff",
      "specialization": "dev",
      "contact_email": "awasrishabh@gmail.com",
      "contact_phone": "08878857588",
      "department": "sev",
      "is_active": true,
      "metadata": {},
      "role_id": 1,
      "last_login": 1
    };

    if (mockPersonnel.personnel_id ) {
      this.personnel = mockPersonnel;
    }
  }
}